import React from 'react'
import { FormattedMessage } from 'react-intl'

export const STEP_KEYS = {
  DELETE_USER: 'DELETE_USER',
  OPTIONAL_SETTINGS: 'OPTIONAL_SETTINGS',
  SUBMIT: 'SUBMIT',
}

export const MODAL_STEPS = [
  {
    label: <FormattedMessage id="ENGAGE.OFFBOARD.DELETE_USER" />,
    key: STEP_KEYS.DELETE_USER,
  },
  {
    label: <FormattedMessage id="GENERAL.OPTIONAL_SETTINGS" />,
    key: STEP_KEYS.OPTIONAL_SETTINGS,
  },
  {
    label: null,
    key: STEP_KEYS.SUBMIT,
  },
]

// do not forget to add new fields to initial values below and to the utils functions (validate, buildInitialValues) in this folder
export const FORM_FIELDS = {
  REMOVE_EMAIL_ALIASES: 'removeEmailAliases',
  REMOVE_DELEGATE_PERMISSIONS: 'removeDelegatePermissions',
  IS_FOWARDING_MAILBOX: 'isForwardingMailbox',
  FORWARD_MAILBOX_TO: 'forwardMailboxTo',
  HIDDEN_FROM_ADDRESS_LIST_ENABLED: 'hiddenFromAddressListEnabled',

  CONVERT_TO_SHARED_MAILBOX: 'convertToSharedMailbox',
  MAILBOX_USERS: 'mailboxUsers',

  // auto reply section
  SEND_AUTOMATIC_REPLIES: 'sendAutomaticReplies',
  SEND_REPLIES_DURING_PERIOD: 'sendRepliesDuringPeriod',
  INTERNAL_REPLY_MESSAGE: 'internalReplyMessage',
  EXTERNAL_REPLY_MESSAGE: 'externalReplyMessage',

  // security actions
  RESET_PASSWORD: 'resetPassword',
  REVOKE_SESSIONS: 'revokeSessions',
  DISABLE_USER: 'disableUser',

  // keep in from groups - for the default settings we just save groups that the user wants to keep in the offboarding
  KEEP_IN_M365_GROUPS: 'keepInM365Groups',
  KEEP_IN_SECURITY_GROUPS: 'keepInSecurityGroups',
  KEEP_IN_DISTRIBUTION_GROUPS: 'keepInDistributionGroups',
  KEEP_IN_SHARED_MAILBOXES: 'keepInSharedMailboxes',
}

export const INITIAL_VALUES = {
  [FORM_FIELDS.REMOVE_EMAIL_ALIASES]: true,
  [FORM_FIELDS.REMOVE_DELEGATE_PERMISSIONS]: true,
  [FORM_FIELDS.IS_FOWARDING_MAILBOX]: false,
  [FORM_FIELDS.FORWARD_MAILBOX_TO]: null,
  [FORM_FIELDS.HIDDEN_FROM_ADDRESS_LIST_ENABLED]: true,

  [FORM_FIELDS.CONVERT_TO_SHARED_MAILBOX]: true,
  [FORM_FIELDS.MAILBOX_USERS]: [],

  // auto reply section
  [FORM_FIELDS.SEND_AUTOMATIC_REPLIES]: false,
  [FORM_FIELDS.SEND_REPLIES_DURING_PERIOD]: false,
  [FORM_FIELDS.INTERNAL_REPLY_MESSAGE]: '',
  [FORM_FIELDS.EXTERNAL_REPLY_MESSAGE]: '',

  [FORM_FIELDS.RESET_PASSWORD]: true,
  [FORM_FIELDS.REVOKE_SESSIONS]: true,
  [FORM_FIELDS.DISABLE_USER]: true,

  // remove from groups
  [FORM_FIELDS.KEEP_IN_M365_GROUPS]: [],
  [FORM_FIELDS.KEEP_IN_SECURITY_GROUPS]: [],
  [FORM_FIELDS.KEEP_IN_DISTRIBUTION_GROUPS]: [],
  [FORM_FIELDS.KEEP_IN_SHARED_MAILBOXES]: [],
}
